<script>
import { removeUrl, removeHtml, reduceMsg, addUrlInNoMsg } from '@/api/Utilities.js'
import * as constant from '@/constant/constant.js'
require('@/css/style.css')

export default {
  props: [
    'card',
    'x',
    'y',
    'w',
    'h',
    'marginX',
    'marginY',
    'isMouseDown'
  ],
  data () {
    return {
      userId: this.card.userId,
      cardId: this.card.id,
      color: this.card.marker,
      msg: this.card.question,
      cardClass: 'card',
      isCardDown: false,
      cardLimit: constant.DEFAULT_CARD_LIMIT
    }
  },
  async created () {
    await this.renderCard()
  },
  watch: {
    card: {
      handler: async function (val) {
        await this.renderCard()
      },
      deep: true
    },
    isMouseDown: function (val) {
      // node外でmouse upされたら取得できないのでTree.vueからisMouseDownをwatch
      if (!this.isMouseDown && this.isCardDown) {
        this.isCardDown = false
        this.touchStartTime = 0
      }
    }
  },
  methods: {
    onCardDown (e) {
      // MouseDown開始時間
      this.isCardDown = true
      this.touchStartTime = e.timeStamp
    },
    onCardMove (e) {
      const deltaTime = (e.timeStamp - this.touchStartTime) / 1000.0
      // nodeDownかつ0.05s以上の操作でDragとする
      if (this.isCardDown && deltaTime >= 0.05) {
        this.$emit('catchNode', this.card, 'card')
      }
    },
    onCardUp (e) {
      // MousDown時間-MouseUp時間 = クリック時間(ms)
      const touchDeltaTime = (e.timeStamp - this.touchStartTime) / 1000.0
      if (touchDeltaTime >= 0.2) { return }
      this.$emit('clickCard', this.card, 'card')
    },
    getUserImageUrl (uid) {
      const targetIndex = this.members.findIndex(({userId}) => userId === uid)
      if (targetIndex === -1) { return null }
      return this.members[targetIndex].imageUrl
    },
    async renderCard () {
      this.userId = this.card.userId
      this.cardId = this.card.cloneCardId
      this.color = this.card.marker
      this.msg = this.card.question
      this.msg = removeHtml(this.msg)
      this.msg = removeUrl(this.msg)
      this.msg = reduceMsg(this.msg, this.cardLimit)
      this.msg = addUrlInNoMsg(this.msg)
      // 初期化
      if (this.color === 'important') {
        this.cardClass = 'cardImportant'
      } else if (this.color === 'thinking') {
        this.cardClass = 'cardThinking'
      } else {
        this.cardClass = 'card'
      }
    }
  }
}
</script>
<style scoped>
.card {
  font-size:0.65rem;
  font-weight: bold;
  position: absolute;
  padding: 15px 8px 8px;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 .25rem .25rem hsla(0, 0%, 0%, .3);
  background-image:
  linear-gradient(180deg, hsla(60, 100%, 85%, 1) 0.5rem, hsla(60, 100%, 85%, 0.5) 0.75rem),
  linear-gradient(180deg, hsla(60, 100%, 85%, 0.2), hsla(60, 100%, 85%, 0.2));
}
.cardImportant {
  font-size:0.65rem;
  font-weight: bold;
  position: absolute;
  padding: 15px 8px 8px;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 .25rem .25rem hsla(0, 0%, 0%, .3);
  background-image:
  linear-gradient(180deg, hsla(100, 100%, 85%, 1) 0.5rem, hsla(100, 100%, 85%, 0.5) 0.75rem),
  linear-gradient(180deg, hsla(100, 100%, 85%, 0.2), hsla(100, 100%, 85%, 0.2));
}
.cardThinking {
  font-size:0.65rem;
  font-weight: bold;
  position: absolute;
  padding: 15px 8px 8px;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 .25rem .25rem hsla(0, 0%, 0%, .3);
  background-image:
  linear-gradient(180deg, hsla(15, 100%, 85%, 0.6) 0.5rem, hsla(15, 100%, 85%, 0.3) 0.75rem),
  linear-gradient(180deg, hsla(15, 100%, 85%, 0.2), hsla(15, 100%, 85%, 0.2));
}
</style>
<template>
<div>
  <!-- Node -->
  <div :class="cardClass" :style="{left:x - 3*w/4 + 'px', top:y + 'px', width:w - marginX + 'px', height:h - marginY + 'px'}" v-on:mousedown="onCardDown" v-on:mousemove="onCardMove" v-on:mouseup="onCardUp">
    <span>{{this.msg}}</span>
  </div>
</div>
</template>



// WEBPACK FOOTER //
// src/pages/tree/graph/SubBoardCard.vue